<template>
  <Page route-path="/lowcode.html">
    <div class="body">
      <div class="first-image">
        <div class="banner-container">
          <img v-if="isNormal" class="backgroud-image" src="@/assets/lowcode/banner.svg" />
          <img v-else class="backgroud-image" src="@/assets/mobile/lowcode/lowcode-banner.svg" />
        </div>
        <div class="head-content">
          <div class="image-title">星河低代码</div>
          <div class="text">面向专业团队和开发者的企业级低代码平台，成熟、开放、高效，<br/>提供先进、敏捷的数字化、智能化生产力。</div>
          <!-- <el-button>免费试用</el-button> -->
        </div>
      </div>

      <div class="lowcode-advantage">
        <div class="title">我们的优势</div>
        <div class="introduction">开箱即用的企业级功能组件，成熟、高效，开放、可充分扩展，支持本地原生语言开发。</div>
        <div class="content">
          <div class="content-box" v-for="(advantage, index) in advantages" :key="index">
            <img :src="advantage.image" alt="" style="width: 100px; height: 100px" />
            <p class="content-box-title">{{ advantage.title }}</p>
            <p class="content-box-text">{{ advantage.text }}</p>
          </div>
        </div>
      </div>

      <div class="increase">
        <div class="title" style="margin: 0">星河低代码能为您带来什么</div>
        <div class="introduction">提供使用简单、功能强大、灵活高效和可扩展的数字化新质生产力，满足客户广泛的应用定制化开发需求。</div>
        <div class="content2">
          <div class="content-box2">
            <div class="box2-top">
              <div class="box2-top-left">提升开发效率</div>
              <div>
                <span class="box2-top-right">100%</span>
                &nbsp;&nbsp;
                <!-- <span style="font-family: Source Han Sans CN-Medium">%</span> -->
              </div>
            </div>
            <div class="box2-bottom">统一模型驱动开发，前后端开发合二为一，轻松搭建全栈团队，专注开发业务核心功能。</div>
          </div>
          <div class="content-box2">
            <div class="box2-top">
              <div class="box2-top-left">降低开发成本</div>
              <div>
                <span class="box2-top-right">50%</span>
                &nbsp;&nbsp;
                <!-- <span style="font-family: Source Han Sans CN-Medium">%</span> -->
              </div>
            </div>
            <div class="box2-bottom">全栈模式降低开发人员需求，开箱即用的组件加快交付，简单易部署降低运维成本。</div>
          </div>
          <div class="content-box2">
            <div class="box2-top">
              <div class="box2-top-left">持续无限扩展</div>
              <div>
                <span class="box2-top-right">&infin;</span>
                &nbsp;&nbsp;
                <!-- <span style="font-family: Source Han Sans CN-Medium"></span> -->
              </div>
            </div>
            <div class="box2-bottom">开源、开放的技术体系，本地原生语言开发应用，在线共享组件生态，可持续无限升级。</div>
          </div>
        </div>
      </div>

      <div class="module3">
        <div class="title"><span>从小白到专家&nbsp;·&nbsp;</span><span>从小团队到大企业&nbsp;·&nbsp;</span><span>业务产品随需应变</span></div>
        <div class="module3-box">
          <div class="box-content"
            style="border-top: 1px solid #efefef; border-bottom: 1px solid #efefef; border-right: 1px solid #efefef; justify-content: flex-end">
            <div class="box-content-inner">
              <div class="box-content-head">
                <span class="box-content-title1">程序员&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="box-content-title2">自由表单+丰富组件，小白程序员也能全栈开发</span>
              </div>
              <ul>
                <li>
                  <div class="box-content-text">自由表单：按需定制数据格式，处理一线业务更加得心应手。</div>
                </li>
                <li>
                  <div class="box-content-text">丰富组件：业务模块开箱即用，复杂业务扩展也能顺手拈来。</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="box-content" style="border-top: 1px solid #efefef; border-bottom: 1px solid #efefef">
            <div class="box-content-inner">
              <div class="box-content-head">
                <span class="box-content-title1">业务专家</span>
                <span class="box-content-title2">可视化建模+元数据驱动，业务协同创新更加游刃有余</span>
              </div>
              <ul>
                <li>
                  <div class="box-content-text">可视化建模：可视化创建统一领域模型，轻松定义业务需求</div>
                </li>
                <li>
                  <div class="box-content-text">元数据驱动：丰富全面的元数据囊括全局要素，产品创新更加灵活</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="box-content"
            style="border-bottom: 1px solid #efefef; border-right: 1px solid #efefef; justify-content: flex-end">
            <div class="box-content-inner">
              <div class="box-content-head">
                <span class="box-content-title1">运维专家</span>
                <span class="box-content-title2">轻量化应用+自动化运维，使业务运营响应更及时</span>
              </div>
              <ul>
                <li>
                  <div class="box-content-text">轻量化应用：简化应用开发，缩短交付周期，加速业务响应。</div>
                </li>
              </ul>
              <ul>
                <li>
                  <div class="box-content-text">自动化运维：简化IT复杂度，降低维护成本，提升IT业务协同效率。</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="box-content" style="border-bottom: 1px solid #efefef">
            <div class="box-content-inner">
              <div class="box-content-head">
                <span class="box-content-title1">老板&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="box-content-title2">开放扩展+安全可控，让老板运筹帷幄、高枕无忧</span>
              </div>
              <ul>
                <li>
                  <div class="box-content-text">开放扩展：促进业务场景落地，加速业务创新验证。</div>
                </li>
              </ul>
              <ul>
                <li>
                  <div class="box-content-text">安全可控：掌握软件与业务知识产权，沉淀应用与数据资产。</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="module4">
        <div class="title" style="margin: 0">企业级安全保障</div>
        <div class="module4-box">
          <div class="module4-box-container">
            <div class="module4-box-item-list">
              <div class="left-item">
                <div class="left-item-title">
                  <img src="@/assets/lowcode/protect_icon1.png" alt=""
                    style="width: 28px; height: 28px; margin-right: 24px" />
                  <p class="left-item-title-p">数据安全</p>
                </div>
                <p class="left-item-text-p">数据指纹防篡改<br />数据变更日志可追溯</p>
              </div>
              <div class="left-item">
                <div class="left-item-title">
                  <img src="@/assets/lowcode/protect_icon2.png" alt=""
                    style="width: 28px; height: 28px; margin-right: 24px" />
                  <p class="left-item-title-p">账号安全</p>
                </div>
                <p class="left-item-text-p">账户多因子验证<br />多级组织/角色授权控制<br /></p>
              </div>
              <div class="left-item">
                <div class="left-item-title">
                  <img src="@/assets/lowcode/protect_icon3.png" alt=""
                    style="width: 28px; height: 28px; margin-right: 24px" />
                  <p class="left-item-title-p">数据备份机制</p>
                </div>
                <p class="left-item-text-p">异地容灾备份 <br /> 本地离线备份</p>
              </div>
              <div class="left-item">
                <div class="left-item-title">
                  <img src="@/assets/lowcode/protect_icon4.png" alt=""
                    style="width: 28px; height: 28px; margin-right: 24px" />
                  <p class="left-item-title-p">多种部署方案</p>
                </div>
                <p class="left-item-text-p">公有云多租户部署<br />混合云部署 <br /> 本地私有化部署</p>
              </div>
            </div>
            <div class="module4-box-banner">
              <img src="@/assets/lowcode/protect2.png" />
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="worth">
        <div class="title">低代码的价值</div>
        <div class="introduction">提供简单的、灵活的、可视化的、高效的开发应用，满足企业服务管理的个性化定制要求</div>
        <div class="worth-box">
          <div :class="index == worthList.length - 1 ? 'worth-item long' : 'worth-item'"
            v-for="(item, index) of worthList" :key="index">
            <div class="worth-item-title">{{ item.title }}</div>
            <div class="worth-item-text">{{ item.text }}</div>
          </div>
        </div>
      </div> -->

      <div class="horizontal-line"></div>

      <div class="process">
        <div class="title">软件开发全流程覆盖</div>
        <div class="process-image">
          <img src="@/assets/lowcode/process1.svg" />
          <div class="circle-module">

            <div class="circle-module-column">
              <div class="circle">
                <img src="@/assets/lowcode/blue-circle.svg" />
                <div class="name">架构设计</div>
              </div>
              <div class="circle">
                <img src="@/assets/lowcode/blue-circle.svg" />
                <div class="name">需求分析</div>
              </div>
            </div>

            <div class="circle-module-column">
              <div class="circle">
                <img src="@/assets/lowcode/light-blue-circle.svg" />
                <div class="name">开发编码</div>
              </div>
              <div class="circle">
                <img src="@/assets/lowcode/green-circle.svg" />
                <div class="name">版本升级</div>
              </div>
            </div>

            <div class="circle-module-column">
              <div class="circle">
                <img src="@/assets/lowcode/blue-circle.svg" />
                <div class="name">系统测试</div>
              </div>
              <div class="circle">
                <img src="@/assets/lowcode/blue-circle.svg" />
                <div class="name">上线运维</div>
              </div>
            </div>
            
          </div>
        </div>
        <div class="description">
          <div class="des-item" v-for="(item, index) in processList" :key="index">
            <div class="des-item-left">
              <div class="left-point"></div>
              <div class="left-title">{{ item.title }}</div>
            </div>
            <div class="des-item-right">
              <div class="right-des">{{ item.description }}</div>
              <div class="right-value">
                <div class="right-value-title">{{ item.value.title }}</div>
                <div class="right-value-value">
                  <div v-for="(itm, key) in item.value.value" :key="key">{{ itm }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="module5">
                <div class="title">低代码正在帮我们改变什么</div>
                <div class="module5-carousel">
                    <div>
                        <img src="@/assets/lowcode/lowcode_backGroud.png" alt="" style="width: 768px;height: 453px;" />
                    </div>
                    <div style="height: 453px;background-color: #242933;flex: 1;">
                    </div>
                    <div class="carousel-swiper">
                        <div ref="mySwiper" class="swiper-container" id="mySwiper">
                            <div class="swiper-wrapper history-events-panel">
                                <div class="swiper-slide history-event" v-for="(item2, i) in [1, 2, 3, 4]" :key="i">
                                    <div class="mask-container">
                                        <div class="mask-container-icon">
                                            <img src="@/assets/lowcode/protect.png" alt=""
                                                style="width: 78px;height: 24px;" />
                                        </div>
                                        <div class="mask-container-title">
                                            富胜家居
                                        </div>
                                        <div class="mask-container-text">
                                            针对家居行业的渠道销营销理提供了数字化解 决方案。系统核心是针对在卖场、渠道等营销 场景提供数字化的报价、订购、价格管理审 批、营销数据统计等功能，支持 Web
                                            PC端、小 程序端。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="padding-left: 320px;padding-top: 28px;display: flex;">
                            <div class="arrowhead" style="margin-right: 32px;">
                                <img src="@/assets/baseIcon/left.png" alt="" style="width: 40px;height: 40px;"
                                    @click="currentSwiper.slidePrev()" />
                            </div>
                            <div class="arrowhead">
                                <img src="@/assets/baseIcon/right.png" alt="arrowhead" style="width: 40px;height: 40px;"
                                    @click="currentSwiper.slideNext()" />
                            </div>
    
                        </div>
                    </div>
                </div>
            </div> -->

      <!-- <div class="module6">
                <div class="module6-content">
                    <P style="font-size: 28px;font-weight: 500;color: #FFFFFF;letter-spacing: 10px;margin-bottom: 24px;">
                        专家在线支持，缩短探索周期</P>
                    <el-button>申请资讯</el-button>
                </div>
            </div> -->
    </div>
  </Page>
</template>
<script>

import { ResponsiveBase } from "../../layout/reponsive-base";

export default {
  name: "LowCode",
  mixins: [ResponsiveBase],

  data() {
    return {
      currentSwiper: null,
      advantages: [
        {
          title: '多',
          text: '丰富的开箱即用的功能组件，全场景通用的账户体系，开放集成丰富的开源生态。',
          image: require("@/assets/lowcode/lowcode-2-1.svg"),
        },
        {
          title: '快',
          text: '使用简单，易上手，采用主流的开发技术栈，零学习门槛，部署简单快速，高性能。',
          image: require("@/assets/lowcode/lowcode-2-2.svg"),
        },
        {
          title: '好',
          text: '低代码+纯代码结合，通用的账户体系，安全灵活的多层授权体系，支持本地开发调试和私有部署。',
          image: require("@/assets/lowcode/lowcode-2-3.svg"),
        },
        {
          title: '省',
          text: '前后端统一的模型驱动开发，轻松实现全栈化开发，降低开发人员需求；部署维护简单，资源消耗少。',
          image: require("@/assets/lowcode/lowcode-2-4.svg"),
        },
      ],
      worthList: [
        {
          title: "快速响应业务变化",
          text: "企业与机构在面对用户需求和市场变化的情况下，需要对既有应用或系统进行功能迭代以及用应用扩展，传统的开发模式需要较长的响应与执行时间，因此用户对快速开发、柔性生产的应用开发方式拥有较高的需求",
        },
        {
          title: "提升运维管理生产力",
          text: "面对业务部门提成的复杂、差异化程度高、零散化的需求，技术人员希望可以实现将重复或者雷同度高的功能组件进行复用进而避免二次开发，另一方面希望可以拥有系统化、可用度高的开发工具对零散化需求进行快速实现",
        },
        {
          title: "全民开发能力建设",
          text: "业务人员也拥有参与开发的机会，更多的碎片化需求得到满足，增强协同，激发创新热情，降低了沟通成本，提升了企业综合运营效能",
        },
        {
          title: "提升技术开发效率",
          text: "低代码实践的主要价值体现在降低开发成本，提升开发效能，需求的敏捷适应性、基础部署与技术管理的高效性等，为专业开发者赋能",
        },
        {
          title: "用低成本的方式开启敏捷创新探索",
          text: "大量的业务人员希望可以通过数字应用开启敏捷业务创新，并对创新想法进行快速验证，面对传统开发模式的冗长流程和高昂成本，用户敏捷管理、快速开发的应用开发方式产生强烈需求",
        },
      ],
      processList: [
        {
          title: '星河在线开发平台',
          description: '可视化专业设计、可视化界面开发、自动化测试、自动化运维、标准化版本管理。',
          value: {
            title: '软件开发应用流程：',
            value: ['需求分析', '架构设计', '系统测试', '上线运维']
          }
        },
        {
          title: '星河开发框架',
          description: '前端框架、后端框架、开发插件、支持多种语言开发。',
          value: {
            title: '软件开发应用流程：',
            value: ['开发编码']
          }
        },
        {
          title: '星河低代码引擎',
          description: '组件化开发方式轻量部署、版本升级、日志管理、控制。',
          value: {
            title: '软件开发应用流程：',
            value: ['版本升级']
          }
        },
      ]
    };
  },
  created() { },
  inject: ["pageIndicator"],
  computed: {},

  mounted() {
    setTimeout(() => {
      this.initSwiper();
    }, 1000);
  },

  methods: {},
};
</script>
<style lang="less" scoped>
.body {
  padding-top: 65px;
}

.banner-container {
  position: absolute;
  top: 64px;
  width: 100%;
  height: 428px;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.backgroud-image {
  height: 100%;
  width: 100%;
  min-width: 1280px;
  object-fit: cover;
}

@media screen and(max-width: 850px) {
  .head-content>.text {
    max-width: 320px;
  }

  .backgroud-image {
    min-width: auto;
  }
}

.first-image {
  height: 428px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  width: 100%;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .head-content {
    width: 100%;
    max-width: 1280px;
    z-index: 1000;
    margin: 0px 20px;

  }

  .image-title {
    height: 58px;
    font-size: 58px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 58px;

    @media screen and (max-width: 850px) {
      font-size: 30px;
    }
  }

  .text {
    width: 600px;
    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #040420;
    line-height: 30px;
    margin-top: 40px;
    margin-bottom: 50px;

    @media screen and (max-width: 850px) {
      font-size: 14px;
      line-height: 24px;

      width: 100%;
    }
  }

  .el-button {
    width: 140px;
    height: 48px;
    font-size: 20px;
    border: 1px solid #ffffff;
    color: #ffffff;
    background-color: #ffffff00;
    font-weight: 500;
  }

  .el-button:hover {
    color: #2e64f3;
    background-color: #ffffff;
  }
}

.title {
  font-size: 36px;
  font-weight: 500;
  color: #040420;
  margin-top: 100px;
  text-align: center;
  -webkit-text-stroke: thin;

  @media screen and (max-width: 850px) {
    font-size: 24px;
  }
}

.lowcode-advantage {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;

  .introduction {
    margin-top: 30px;
    font-size: 20px;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    text-align: center;

    @media screen and (max-width: 850px) {
      font-size: 14px;
      line-height: 24px;
    }
  }
}

.content {
  max-width: 1280px;
  width: 100%;
  padding: 60px 20px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 30px;
  column-gap: 30px;

  .content-box {
    width: 260px;
    text-align: center;
  }

  .content-box-title {
    font-size: 24px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    margin: 36px 0px 24px;

    @media screen and (max-width: 850px) {
      font-size: 18px;
    }
  }

  .content-box-text {
    width: 100%;

    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;

    text-align: left;

    @media screen and (max-width: 850px) {
      font-size: 14px;
      line-height: 24px;
    }
  }
}

@media screen and (max-width: 1250px) {
  .lowcode-advantage .content {
    justify-content: center;
    column-gap: 28px;
  }
}

@media screen and (max-width: 850px) {
  .lowcode-advantage {
    padding: 0px 20px;

    .content {
      justify-content: center;
      column-gap: 28px;
    }
  }
}

.content2 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
  margin-top: 60px;
  column-gap: 30px;
  row-gap: 30px;

  .content-box2 {
    height: 178px;
    width: 390px;
    background-color: #ffffff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    padding: 8px 30px 30px 30px;

    .box2-top {
      display: flex;
      justify-content: space-between;

      //align-items: baseline;
      @media screen and (max-width: 850px) {
        align-items: baseline;
        justify-content: flex-start;
        column-gap: 10px;
      }

      .box2-top-left {
        font-size: 24px;
        font-weight: blod;
        color: #040420;
        font-family: Source Han Sans CN-Medium;
        margin-top: 30px;
        -webkit-text-stroke: thin;

        @media screen and (max-width: 850px) {
          font-size: 18px;
        }
      }

      .box2-top-right {
        font-size: 60px;
        font-weight: 500;
        font-family: Source Han Sans CN-Medium;
        color: #2e64f3;
        -webkit-text-stroke: thin;

        @media screen and (max-width: 850px) {
          font-size: 40px;
          line-height: 24px;
        }
      }
    }

    .box2-bottom {
      font-size: 16px;
      font-family: Source Han Sans CN-Medium;
      font-weight: 400;
      color: #727272;
      line-height: 24px;
      margin-top: 12px;

      @media screen and (max-width: 850px) {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }

  .content-box2:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12), 0 0 12px rgba(0, 0, 0, 0.04);
  }

  @media screen and (max-width: 1250px) {
    justify-content: center;
  }

  @media screen and (max-width: 850px) {
    .content-box2 {
      width: 100%;
      height: auto;
      min-height: 178px;
    }
  }
}

.increase {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 20px 100px 20px;
  background: url(../../assets/lowcode/backgroud.png) no-repeat center center;
  background-size: 100% 100%;

  .introduction {
    margin-top: 30px;
    font-size: 20px;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    text-align: center;

    @media screen and (max-width: 850px) {
      font-size: 14px;
      line-height: 24px;
    }
  }
}

.module3 {
  padding: 0;

  .title {
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 30px;

    padding: 0 20px;

    font-weight: 300;

    span {
      min-width: 200px;
    }
  }
}

.module3-box {
  margin-top: 62px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .box-content {
    width: 50%;
    padding: 30px 30px 30px 30px;
    display: flex;

    .box-content-inner {
      max-width: 610px;
      width: 100%;
    }

    .box-content-head {
      padding-bottom: 15px;

      @media screen and(max-width: 850px) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding-left: 25px;
      }
    }

    .box-content-title1 {
      font-size: 24px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #040420;

      @media screen and (max-width: 850px) {
        font-size: 18px;
      }
    }

    .box-content-title2 {
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #2e64f3;
      margin-left: 24px;

      @media screen and (max-width: 850px) {
        margin-top: 8px;
        margin-left: 0px;
        font-size: 14px;
        line-height: 24px;
      }
    }

    .box-content-text {
      font-size: 18px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #727272;
      margin-top: 20px;

      @media screen and (max-width: 850px) {
        font-size: 14px;
        line-height: 24px;
      }

      @media screen and(max-width: 600px) {
        margin-top: 14px;
      }
    }
  }

  @media screen and (max-width: 1120px) {
    .box-content {
      width: 100%;
      flex-direction: row;
      justify-content: center !important;
    }
  }
}

.module4 {
  min-height: 624px;
  background-color: #f8f9f9;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .module4-box {
    display: flex;
    width: 100%;
    max-width: 1280px;
    margin-top: 50px;

    .module4-box-container {
      position: relative;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      @media screen and (max-width: 600px) {
        position: unset;
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        row-gap: 30px;
      }

      .module4-box-banner {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        img {
          width: 317px;
          height: 343px;
        }

        @media screen and (max-width: 920px) {
          justify-content: flex-end;
          padding-right: 60px;
        }

        @media screen and (max-width: 600px) {
          position: inherit;
          width: 150px;
          height: 150px;
          padding-right: 0px;

          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;

            padding-right: 0px;
          }
        }
      }

      .module4-box-item-list {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        z-index: 1000;
        justify-content: space-between;
        column-gap: 380px;

        padding: 0 30px;

        @media screen and (max-width: 920px) {
          padding-left: 100px;
        }

        @media screen and (max-width: 600px) {
          padding: 0 15px;
          justify-content: center;
          column-gap: 15px;
          row-gap: 15px;
        }
      }

      .left-item {
        padding: 30px 0;
        // max-height: 100px;
        width: 240px;
        box-sizing: border-box;
        min-height: 180px;

        @media screen and (max-width: 600px) {
          padding: 0px 0;
          width: 180px;
          // min-height: 180px;
        }
      }

      .left-item-title {
        display: flex;
        align-items: center;
        margin-bottom: 27px;
      }

      .left-item-title-p {
        font-size: 24px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #040420;
        line-height: 0px;

        @media screen and (max-width: 850px) {
          font-size: 18px;
        }
      }

      .left-item-text-p {
        width: 100%;
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #727272;
        line-height: 32px;
        padding-left: 52px;

        @media screen and (max-width: 850px) {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
  }
}

.worth {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;

  .introduction {
    margin-top: 30px;
    font-size: 20px;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    text-align: center;

    @media screen and (max-width: 850px) {
      font-size: 14px;
      line-height: 24px;
      padding: 0px 50px;
    }
  }

  .worth-box {
    max-width: 1280px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 60px;
    column-gap: 28px;
    row-gap: 28px;

    padding: 0;

    @media screen and(max-width: 1280px) {
      padding: 0px 30px;
    }

    .worth-item {
      width: 299px;
      height: 394px;
      background: #f0f2f9;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      padding: 48px 32px;

      @media screen and(max-width: 1280px) {
        width: 48%;
        min-width: 300px;
        height: auto;
      }

      @media screen and(max-width: 850px) {
        width: 100%;
        height: auto;
      }

      @media screen and(max-width: 600px) {
        min-width: 100px;
      }

      .worth-item-title {
        font-size: 24px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #040420;
        border-left: 6px solid #2e64f3;
        padding-left: 12px;
        margin-bottom: 25px;

        @media screen and (max-width: 850px) {
          font-size: 18px;
        }
      }

      .worth-item-text {
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #727272;
        line-height: 32px;

        @media screen and (max-width: 850px) {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }

    .worth-item:hover {
      background: #ffffff;
      box-shadow: 5px 5px 15px 1px rgba(96, 129, 217, 0.15);
    }

    .long {
      max-width: 100%;
      width: 100%;
      height: 202px;

      @media screen and (max-width: 850px) {
        height: auto;
      }
    }
  }
}

.horizontal-line {
  width: 100%;
  height: 2px;
  background: #E6E8EC;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

/**
软件开发全流程覆盖
*/
.process {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;

  .process-image{
    display: flex;
    position: relative;
    height: 925px;
    width: 990px;
    margin: 51px 0px 49px;

    @media screen and (max-width: 850px) {
      height: 475px;
      width: 540px;
    }
    .circle-module{
      position: absolute;
      width: 100%;
      height: 100%;
      display: grid;/* 声明一个容器 */
      grid-template-columns: repeat(3, 330px);/*  声明列的宽度  */
      grid-gap: 0px;/*  声明行间距和列间距  */
      grid-template-rows: 100%;/*  声明行的高度  */

      @media screen and (max-width: 850px) {
        grid-template-columns: repeat(3, 180px);
      }
      .circle-module-column{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .circle{
          width: 128px;
          height: 128px;
          display: flex;
          position: relative;

          @media screen and (max-width: 850px) {
            width: 69px;
            height: 69px;
          }

          .name{
            position: absolute;
            width: 80px;
            height: 20px;
            font-size: 20px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 0px;
            left: 50%;    //起始是在body中，横向距左50%的位置
            top:58%;      //起始是在body中，纵向距上50%的位置，这个点相当于body的中心点，div的左上角的定位
            transform:translate(-50%,-50%);//水平、垂直都居中,也可以写成下面的方式

            @media screen and (max-width: 850px) {
              width: 50px;
              height: 20px;
              font-size: 12px;
              top:64%;
            }
          }
        }
      }
      .circle-module-column:first-child{
        justify-content: space-between;
        padding: 195px 0px 209px;
        @media screen and (max-width: 850px) {
          padding: 90px 0px 100px;
        }
      }
      .circle-module-column:last-child{
        justify-content: space-between;
        padding: 195px 0px 209px;
        @media screen and (max-width: 850px) {
          padding: 90px 0px 100px;
        }
      }
    }
  }

  .description {
    max-width: 1280px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 54px;
    @media screen and (max-width: 850px) {
      row-gap: 36px;
    }

    .des-item {
      display: flex;

      @media screen and (max-width: 850px) {
        flex-direction: column;
      }

      .des-item-left {
        display: flex;
        align-items: flex-start;

        .left-point {
          width: 20px;
          height: 20px;
          opacity: 1;
          display: inline-block;
          padding: 3px;
          border: 1px solid #306BFC;
          border-radius: 50%;
          background-color: #306BFC;
          background-clip: content-box;
          margin-right: 20px;
          margin-top: 3px;
          @media screen and (max-width: 850px) {
            margin-right: 10px;
          }
        }

        .left-title {
          width: 216px;
          height: 24px;
          font-size: 24px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #040420;
          line-height: 24px;
          -webkit-background-clip: text;

          @media screen and (max-width: 850px) {
            font-size: 18px;
            line-height: 22px;
          }
        }
      }

      .des-item-right {
        margin-left: 32px;
        display: flex;
        flex-direction: column;

        @media screen and (max-width: 850px) {
          margin-left: 0px;
          padding-left: 30px;
        }

        .right-des {
          width: 648px;
          height: 18px;
          font-size: 18px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #727272;
          line-height: 28px;
          margin-bottom: 32px;

          @media screen and (max-width: 850px) {
            width: 348px;
            height: auto;
            font-size: 14px;
            line-height: 22px;
            margin: 10px 0px;
          }
        }

        .right-value {
          display: flex;
          @media screen and (max-width: 850px) {
              width: 348px;
          }
          .right-value-title {
            width: 162px;
            height: 18px;
            font-size: 18px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #040420;
            line-height: 32px;

            @media screen and (max-width: 850px) {
              width: 128px;
              font-size: 14px;
              line-height: 22px;
            }
          }

          .right-value-value {
            display: flex;
            flex-wrap: wrap;
            flex: 1;

            @media screen and (max-width: 850px) {
              row-gap: 8px;
            }
          }

          .right-value-value div {
            width: 72px;
            height: 18px;
            font-size: 18px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #306BFC;
            line-height: 32px;
            margin: 0px 12px;

            @media screen and (max-width: 850px) {
              font-size: 14px;
              line-height: 22px;
              margin: 0px 6px;
            }
          }
        }
      }
    }
  }
}

/**
废弃css
*/
.module5 {
  .module5-carousel {
    height: 453px;
    margin-top: 59px;
    display: flex;
    position: relative;
  }
}

.module6 {
  background: url(../../assets/lowcode/module6.png) no-repeat center center;
  background-size: 100% 100%;
  margin-top: 32px;
  height: 160px;

  .module6-content {
    padding: 34px 320px;

    .el-button {
      width: 168px;
      height: 40px;
      font-size: 20px;
      border: 1px solid #ffffff;
      color: #ffffff;
      background-color: #ffffff00;
      font-weight: 500;
    }

    .el-button:hover {
      color: #2e64f3;
      background-color: #ffffff;
    }
  }
}

.mask-container {
  padding: 30px 40px;
}

.mask-container-icon {}

.mask-container-title {
  font-size: 20px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #040420;
  height: 20px;
  margin: 32px 0px 20px;
}

.mask-container-text {
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
}

.arrowhead {
  background-color: gray;
  border-radius: 50%;
  opacity: 0.3;
  height: 40px;
  width: 40px;
}

.arrowhead:hover {
  background-color: #ffffff00;
  opacity: unset;
}</style>
